import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppService } from './services/app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Digital Union SaaS';
  showNavigation = true;
  isAdminPage = false;
  isUsersStatusPage = false;
  private routerSubscription: Subscription = new Subscription();

  constructor(
    private appService: AppService,
    private router: Router
  ) {}

  ngOnInit() {
    // Check initial route
    this.checkRoute(this.router.url);
    
    // Subscribe to route changes
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRoute(event.url);
      });
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  private checkRoute(url: string) {
    // Hide navigation on auth pages and users-status page
    this.showNavigation = !url.includes('/auth') && !url.includes('/users-status');
    // Check if we're on any admin page
    this.isAdminPage = url.includes('/admin');
    // Check if we're on users-status page
    this.isUsersStatusPage = url.includes('/users-status');
  }

  getClasses() {
    const classes = {
      'pinned-sidebar': this.appService.getSidebarStat().isSidebarPinned,
      'toggled-sidebar': this.appService.getSidebarStat().isSidebarToggled,
      'modern-layout': true,
      'auth-layout': !this.showNavigation && !this.isUsersStatusPage,
      'users-status-layout': this.isUsersStatusPage
    }
    return classes;
  }

  toggleSidebar() {
    this.appService.toggleSidebar();
  }
}
